import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

export default function Hero() {
  const { t } = useLanguage();
  const waLink = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent("Hola Amaranto, me gustaría conocer las colecciones.")}`;

  return (
    <section data-testid="hero-section" className="relative min-h-screen bg-cream paper-grain pt-32 pb-20 overflow-hidden">
      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center min-h-[80vh]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.2, 0.7, 0.2, 1] }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-px bg-warmbrown" />
            <span className="eyebrow" data-testid="hero-eyebrow">{t.hero.eyebrow}</span>
          </div>

          <h1 data-testid="hero-title" className="font-serif text-[clamp(2.8rem,7vw,6.2rem)] leading-[0.96] tracking-tight text-ink">
            {t.hero.title1}
            <br />
            <span className="italic font-normal text-warmbrown">{t.hero.title2}</span>
          </h1>

          <p data-testid="hero-sub" className="mt-10 max-w-xl font-body text-base md:text-lg leading-relaxed text-ink-soft">
            {t.hero.sub}
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-5">
            <a href={waLink} target="_blank" rel="noreferrer" data-testid="hero-whatsapp-cta"
              className="inline-flex items-center gap-3 bg-warmbrown hover:bg-warmbrown-deep text-cream px-8 py-4 text-[11px] tracking-[0.3em] uppercase font-semibold transition-all duration-500">
              <span className="w-1.5 h-1.5 rounded-full bg-dustyrose" />
              {t.hero.cta1}
            </a>
            <a href="#kits" data-testid="hero-collections-cta"
              className="inline-flex items-center gap-3 text-ink border-b border-ink pb-1 text-[11px] tracking-[0.3em] uppercase font-semibold hover:text-dustyrose-deep hover:border-dustyrose-deep transition-colors duration-500">
              {t.hero.cta2} →
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.6, delay: 0.2, ease: [0.2, 0.7, 0.2, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img src="/catalog/img1.jpg" alt="Amaranto — Colección Esencial"
              className="w-full h-full object-cover" data-testid="hero-product-image" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-paper border border-cream-300 px-6 py-4 hidden md:block">
            <p className="font-serif italic text-sm text-ink-soft">Colección Esencial</p>
            <p className="eyebrow mt-1">Atemporal · Edición limitada</p>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-ink-soft">
        <span className="text-[10px] tracking-[0.3em] uppercase">scroll</span>
        <div className="w-px h-10 bg-ink-soft/60" />
      </div>
    </section>
  );
}
